import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled, { css } from "styled-components";
import { useTranslation } from "../../i18n/useTranslation";
import { cssBody100 } from "../typography/styles";
export const NoOptionsWrapper = styled.div `
  padding: 8px 16px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const _NoOptions = ({ className }) => {
    const { t } = useTranslation();
    return _jsx(NoOptionsWrapper, { className: className, children: t("common.noOptions") });
};
export const NoOptions = Object.assign(_NoOptions, { Wrapper: NoOptionsWrapper });
export const renderNoOptionsDefault = () => _jsx(NoOptions, {});
export const createIndex = -1;
export const renderCreateDefault = ({ value, highlighted, onCreate }) => {
    return (_jsxs(TagOption, { "$highlighted": highlighted, role: "option", "data-index": createIndex, onClick: () => onCreate?.(value), children: ["Create ", _jsx("span", { children: value })] }));
};
export const renderItemDefault = ({ option, onSelect, highlighted }) => {
    return (_jsx(TagOption, { onClick: () => onSelect(option), "$highlighted": highlighted, role: "option", "data-index": option.index, children: _jsx(TagLabel, { children: option.label }) }));
};
export const TagOption = styled.div `
  ${cssBody100};
  height: 32px;
  display: flex;
  align-items: center;
  padding: 0 12px;
  color: #000;

  span {
    font-weight: 700;
    margin-left: 4px;
  }

  &:hover {
    background-color: ${(p) => p.theme.systemColors.grey100};
  }

  ${(p) => p.$highlighted &&
    css `
      background-color: ${(p) => p.theme.systemColors.grey100};
    `}
`;
export const TagLabel = styled.div `
  ${cssBody100};
  font-weight: 700;
  color: #fff;
  padding: 4px 8px;
  border-radius: 100px;
  background-color: ${(p) => p.theme.systemColors.grey800};
`;
